module.exports = {
  geniusApi: {
    BASE_URL: 'https://api.genius.com/',
    ACCESS_TOKEN: 'nGp3pBMK5Mx0WWHN3OrNLXoyeg7L4fCwDNB8_tsYLV3-92vF6pmI3g9hBFjesdMB',
  },
  spotifyApi: {
    BASE_URL: 'https://api.spotify.com/v1/',
    AUTH_URL: 'https://accounts.spotify.com/api/token',
    CLIENT_ID: '36ae9b0dbb7e49d3960ed4e8f618533c',
    CLIENT_SECRET: 'f9f5e0bfe1b44544922e30ad4f3715de',
  },
};
